import { useContext } from "react";
import { BranchContext } from "../Contexts/branch-context/BranchContext";

export const useBranch = () => useContext(BranchContext);
